/**
 * Formats a date's month/day/year driven explicitly by `lang` rather than moment's global
 * locale -- mirrors the pattern in formatRelativeTime.ts / PainterScheduleView/dateUtils.ts:
 * moment's locale data depends on the right `moment/locale/*` file being registered on the
 * exact same bundled moment instance doing the formatting, which isn't reliable across
 * packages/apps and silently falls back to English on any mismatch. Intl draws on the
 * browser's built-in ICU data, so it can't silently fall back this way.
 */
export function formatMonthDayYear(date: Date | number, lang: string, month: 'short' | 'long' = 'short'): string {
  return new Intl.DateTimeFormat(lang, { month, day: 'numeric', year: 'numeric' }).format(date)
}
